import { render, staticRenderFns } from "./alert_index.vue?vue&type=template&id=c83aa446&scoped=true&"
import script from "./alert_index.vue?vue&type=script&lang=js&"
export * from "./alert_index.vue?vue&type=script&lang=js&"
import style0 from "./alert_index.vue?vue&type=style&index=0&id=c83aa446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83aa446",
  null
  
)

export default component.exports